<template>
  <ts-loading-banner :loading="waiting">
    <div class="tw-space-y-4">
      <div class="row">
        <div class="col-md-12 tw-space-y-1">
          <label class="required">{{
            $t("employeeStatusReason.status")
          }}</label>
          <select
            v-model="model.status_id"
            class="form-control"
            :class="{
              'is-invalid': errors.has('status_id'),
            }"
          >
            <option :value="null" selected disabled style="display: none">
              {{ $t("select") }}
            </option>
            <option
              v-for="(sta, index) in status"
              :key="index"
              :value="sta.status_id"
            >
              {{ sta.status }}
            </option>
          </select>
          <div class="invalid-feedback" v-if="errors.has('status_id')">
            {{ errors.first("status_id") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 tw-space-y-1">
          <label class="required">{{
            $t("employeeStatusReason.reason")
          }}</label>
          <input
            v-model="model.reason"
            type="text"
            class="form-control"
            :class="{
              'is-invalid': errors.has('reason'),
            }"
            :placeholder="$t('employeeStatusReason.reason')"
          />
          <div class="invalid-feedback" v-if="errors.has('reason')">
            {{ errors.first("reason") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 tw-flex tw-justify-end tw-space-x-3">
          <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
            {{ $t("cancel") }}
          </ts-button>
          <ts-button v-if="!isUpdate" color="primary" @click.prevent="onSave">{{
            $t("save")
          }}</ts-button>
          <ts-button
            v-if="isUpdate"
            color="primary"
            @click.prevent="onUpdate"
            >{{ $t("update") }}</ts-button
          >
        </div>
      </div>
    </div>
  </ts-loading-banner>
</template>

<script>
import { isEmpty } from "lodash";
import { mapState } from "vuex";
import { Errors } from "form-backend-validation";

export default {
  name: "employeeStatusReasonForm",
  data() {
    return {
      waiting: false,
      errors: new Errors(),
      showBrowseFileBotton: false,
      status: [],
      model: {
        status_reason_id: null,
        status_id: null,
        reason: null,
        is_paid: false,
      },
    };
  },
  computed: {
    ...mapState("humanResource/employeeStatusReason", ["edit_data"]),
    isUpdate() {
      return !isEmpty(this.edit_data);
    },
  },
  async created() {
    await this.fetchFormViewModel();
    this.setEditData();
  },
  methods: {
    async onSave() {
      this.waiting = true;
      this.$store
        .dispatch("humanResource/employeeStatusReason/store", this.model)
        .then(async (response) => {
          this.$notify({ type: "success", text: response.message });
          this.$emit("fetchData");
          this.$emit("cancel");
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
          this.errors = new Errors(error.errors);
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    async onUpdate() {
      this.waiting = true;
      this.$store
        .dispatch("humanResource/employeeStatusReason/update", {
          id: this.edit_data.status_reason_id,
          data: this.model,
        })
        .then(async (response) => {
          this.$notify({ type: "success", text: response.message });
          this.$emit("cancel");
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
          this.errors = new Errors(error.errors);
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    fetchFormViewModel() {
      this.waiting = true;
      this.$store
        .dispatch("humanResource/employeeStatusReason/getFormViewData")
        .then((response) => {
          this.status = response.data.status;
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    setEditData() {
      if (!isEmpty(this.edit_data)) {
        this.model.status_reason_id = this.edit_data.status_reason_id;
        this.model.reason = this.edit_data.reason;
        this.model.status_id = this.edit_data.status_id;
        this.model.is_paid = this.edit_data.is_paid;
      }
    },
  },
};
</script>
